<template>
  <span>
    <charts-serv-comercial
      :dadosPsfp="dadosPsfp"
      :dadosPatc="dadosPatc"
      :dadosRealizadosVsAtraso="dadosRealizadosVsAtraso"
      :dadosCompensacoesServicosConcluidasForaPrazo="
        dadosCompensacoesServicosConcluidasForaPrazo
      "
      :dadosCompensacoesPagasUnidadesConsumidoras="
        dadosCompensacoesPagasUnidadesConsumidoras
      "
      :dadosVolumeTotalCompensacoes="dadosVolumeTotalCompensacoes"
      :dadosQSPServicos="dadosQSPServicos"
      :dadosPSAServicos="dadosPSAServicos"
      :dadosPATServicos="dadosPATServicos"
      :loadingPorChave="loadingPorChave"
    />
  </span>
</template>

<script>
  import DashboardServicosService from "@/services/DashboardServicosService";

  export default {
    name: "DashboardServicosVisaoServicos.vue",
    components: {
      ChartsServComercial: () => import("./visaoServicos/ChartsServComercial"),
      TableServComercial: () => import("./visaoServicos/TableServComercial"),
    },
    props: {
      competenciaDe: {
        type: String,
        required: true,
      },
      competenciaAte: {
        type: String,
        required: true,
      },
      activatedTab: {
        type: Number,
        required: true,
      },
      servicosSelecionados: {
        type: Array,
        required: true,
      },
      regionalSelecionada: {
        type: Number,
        required: true,
      },
    },
    data: () => ({
      dadosPsfp: { data: [] },
      dadosPatc: { data: [] },
      dadosRealizadosVsAtraso: { data: [] },
      dadosCompensacoesServicosConcluidasForaPrazo: { data: [] },
      dadosCompensacoesPagasUnidadesConsumidoras: { data: [] },
      dadosVolumeTotalCompensacoes: { data: [] },
      dadosQSPServicos: { data: [] },
      dadosPSAServicos: { data: [] },
      dadosPATServicos: { data: [] },
      traducaoIndicadores: {
        descricao: "Descrição do serviço prestado",
        valor_total: "Soma total de todos os meses do período",
      },
      loadingPorChave: {
        psfp: false,
        patc: false,
        realizadosVsAtraso: false,
        compensacoesServicosConcluidasForaPrazo: false,
        compensacoesPagasUnidadesConsumidoras: false,
        volumeTotalCompensacoes: false,
        qspServicos: false,
        psaServicos: false,
        patServicos: false,
      },
      isFetching: false,
    }),
    mounted() {
      this.getDados();
    },
    methods: {
      finalizarLoadingDados() {
        this.$emit("updateLoadingDadosTable", false);
        this.isFetching = false;
      },
      scheduleGetDados() {
        this.getDados();
      },
      getDados() {
        if (this.activatedTab !== 1) {
          this.finalizarLoadingDados();
          return;
        }
        if (
          !this.servicosSelecionados ||
          this.servicosSelecionados.length === 0 ||
          this.regionalSelecionada === 0
        ) {
          this.finalizarLoadingDados();
          return;
        }
        if (this.isFetching) {
          return;
        }

        this.isFetching = true;
        this.$emit("updateLoadingDadosTable", true);

        const promises = [
          this.getDadosPsfp(),
          this.getDadosPatc(),
          this.getDadosServRealizadosVsAtraso(),
          this.getGraficosCompensacoesServicosConcluidasForaPrazo(),
          this.getGraficosCompensacoesPagasUnidadesConsumidoras(),
          this.getVolumeTotalCompensacoes(),
          this.getQSPServicos(),
          this.getPSAServicos(),
          this.getPATServicos(),
        ];

        Promise.allSettled(promises)
          .then((results) => {
            const hasError = results.some((r) => r.status === "rejected");
            if (hasError) {
              this.$toast.error("Erro ao recuperar parte dos dados.", "", {
                position: "topRight",
              });
            }
          })
          .finally(() => {
            this.finalizarLoadingDados();
          });
      },
      getDadosPsfp() {
        this.loadingPorChave.psfp = true;
        return DashboardServicosService.getDadosPsfp(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosPsfp = res;
          })
          .finally(() => {
            this.loadingPorChave.psfp = false;
          });
      },
      getDadosPatc() {
        this.loadingPorChave.patc = true;
        return DashboardServicosService.getDadosPatc(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosPatc = res;
          })
          .finally(() => {
            this.loadingPorChave.patc = false;
          });
      },
      getDadosServRealizadosVsAtraso() {
        this.loadingPorChave.realizadosVsAtraso = true;
        return DashboardServicosService.getDadosServRealizadosVsAtraso(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosRealizadosVsAtraso = res;
          })
          .finally(() => {
            this.loadingPorChave.realizadosVsAtraso = false;
          });
      },
      getGraficosCompensacoesServicosConcluidasForaPrazo() {
        this.loadingPorChave.compensacoesServicosConcluidasForaPrazo = true;
        return DashboardServicosService.getGraficosCompensacoesServicosConcluidasForaPrazo(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosCompensacoesServicosConcluidasForaPrazo = res;
          })
          .finally(() => {
            this.loadingPorChave.compensacoesServicosConcluidasForaPrazo = false;
          });
      },
      getGraficosCompensacoesPagasUnidadesConsumidoras() {
        this.loadingPorChave.compensacoesPagasUnidadesConsumidoras = true;
        return DashboardServicosService.getGraficosCompensacoesPagasUnidadesConsumidoras(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosCompensacoesPagasUnidadesConsumidoras = res;
          })
          .finally(() => {
            this.loadingPorChave.compensacoesPagasUnidadesConsumidoras = false;
          });
      },
      getVolumeTotalCompensacoes() {
        this.loadingPorChave.volumeTotalCompensacoes = true;
        return DashboardServicosService.getVolumeTotalCompensacoes(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosVolumeTotalCompensacoes = res;
          })
          .finally(() => {
            this.loadingPorChave.volumeTotalCompensacoes = false;
          });
      },
      getQSPServicos() {
        this.loadingPorChave.qspServicos = true;
        return DashboardServicosService.getQSPServicos(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosQSPServicos = res;
          })
          .finally(() => {
            this.loadingPorChave.qspServicos = false;
          });
      },
      getPSAServicos() {
        this.loadingPorChave.psaServicos = true;
        return DashboardServicosService.getPSAServicos(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosPSAServicos = res;
          })
          .finally(() => {
            this.loadingPorChave.psaServicos = false;
          });
      },
      getPATServicos() {
        this.loadingPorChave.patServicos = true;
        return DashboardServicosService.getPATServicos(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosPATServicos = res;
          })
          .finally(() => {
            this.loadingPorChave.patServicos = false;
          });
      },
    },
    watch: {
      competenciaDe() {
        this.scheduleGetDados();
      },
      competenciaAte() {
        this.scheduleGetDados();
      },
      servicosSelecionados() {
        this.scheduleGetDados();
      },
      regionalSelecionada() {
        this.scheduleGetDados();
      },
    },
  };
</script>

<style></style>
